/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.AccountBalance = (function() {

    /**
     * Properties of an AccountBalance.
     * @exports IAccountBalance
     * @interface IAccountBalance
     * @property {number|null} [balance] AccountBalance balance
     * @property {string|null} [currency] AccountBalance currency
     * @property {number|null} [credit] AccountBalance credit
     */

    /**
     * Constructs a new AccountBalance.
     * @exports AccountBalance
     * @classdesc Represents an AccountBalance.
     * @implements IAccountBalance
     * @constructor
     * @param {IAccountBalance=} [properties] Properties to set
     */
    function AccountBalance(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * AccountBalance balance.
     * @member {number} balance
     * @memberof AccountBalance
     * @instance
     */
    AccountBalance.prototype.balance = 0;

    /**
     * AccountBalance currency.
     * @member {string} currency
     * @memberof AccountBalance
     * @instance
     */
    AccountBalance.prototype.currency = "";

    /**
     * AccountBalance credit.
     * @member {number} credit
     * @memberof AccountBalance
     * @instance
     */
    AccountBalance.prototype.credit = 0;

    /**
     * Creates a new AccountBalance instance using the specified properties.
     * @function create
     * @memberof AccountBalance
     * @static
     * @param {IAccountBalance=} [properties] Properties to set
     * @returns {AccountBalance} AccountBalance instance
     */
    AccountBalance.create = function create(properties) {
        return new AccountBalance(properties);
    };

    /**
     * Encodes the specified AccountBalance message. Does not implicitly {@link AccountBalance.verify|verify} messages.
     * @function encode
     * @memberof AccountBalance
     * @static
     * @param {IAccountBalance} message AccountBalance message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AccountBalance.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.balance != null && Object.hasOwnProperty.call(message, "balance"))
            writer.uint32(/* id 1, wireType 1 =*/9).double(message.balance);
        if (message.currency != null && Object.hasOwnProperty.call(message, "currency"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.currency);
        if (message.credit != null && Object.hasOwnProperty.call(message, "credit"))
            writer.uint32(/* id 3, wireType 1 =*/25).double(message.credit);
        return writer;
    };

    /**
     * Encodes the specified AccountBalance message, length delimited. Does not implicitly {@link AccountBalance.verify|verify} messages.
     * @function encodeDelimited
     * @memberof AccountBalance
     * @static
     * @param {IAccountBalance} message AccountBalance message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AccountBalance.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an AccountBalance message from the specified reader or buffer.
     * @function decode
     * @memberof AccountBalance
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {AccountBalance} AccountBalance
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AccountBalance.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.AccountBalance();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.balance = reader.double();
                    break;
                }
            case 2: {
                    message.currency = reader.string();
                    break;
                }
            case 3: {
                    message.credit = reader.double();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an AccountBalance message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof AccountBalance
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {AccountBalance} AccountBalance
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AccountBalance.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an AccountBalance message.
     * @function verify
     * @memberof AccountBalance
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    AccountBalance.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.balance != null && message.hasOwnProperty("balance"))
            if (typeof message.balance !== "number")
                return "balance: number expected";
        if (message.currency != null && message.hasOwnProperty("currency"))
            if (!$util.isString(message.currency))
                return "currency: string expected";
        if (message.credit != null && message.hasOwnProperty("credit"))
            if (typeof message.credit !== "number")
                return "credit: number expected";
        return null;
    };

    /**
     * Creates an AccountBalance message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof AccountBalance
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {AccountBalance} AccountBalance
     */
    AccountBalance.fromObject = function fromObject(object) {
        if (object instanceof $root.AccountBalance)
            return object;
        var message = new $root.AccountBalance();
        if (object.balance != null)
            message.balance = Number(object.balance);
        if (object.currency != null)
            message.currency = String(object.currency);
        if (object.credit != null)
            message.credit = Number(object.credit);
        return message;
    };

    /**
     * Creates a plain object from an AccountBalance message. Also converts values to other types if specified.
     * @function toObject
     * @memberof AccountBalance
     * @static
     * @param {AccountBalance} message AccountBalance
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    AccountBalance.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.balance = 0;
            object.currency = "";
            object.credit = 0;
        }
        if (message.balance != null && message.hasOwnProperty("balance"))
            object.balance = options.json && !isFinite(message.balance) ? String(message.balance) : message.balance;
        if (message.currency != null && message.hasOwnProperty("currency"))
            object.currency = message.currency;
        if (message.credit != null && message.hasOwnProperty("credit"))
            object.credit = options.json && !isFinite(message.credit) ? String(message.credit) : message.credit;
        return object;
    };

    /**
     * Converts this AccountBalance to JSON.
     * @function toJSON
     * @memberof AccountBalance
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    AccountBalance.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for AccountBalance
     * @function getTypeUrl
     * @memberof AccountBalance
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    AccountBalance.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/AccountBalance";
    };

    return AccountBalance;
})();

module.exports = $root;
